import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class ConfigService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public GetSystemConfigurations(): Promise<SystemConfigurationModel> {
        var url = '/config/GetSystemConfigurations';
        return this.httpget<any>(url);
    }

    public SaveSystemConfigurations(configModel:SystemConfigurationModel): Promise<any> {
        var url = '/config/SaveSystemConfigurations';
        return this.httppost<any>(url, configModel);
    }
}

export class SystemConfigurationModel {
    public AnnualReportDueDate: string;
    public AnnualReminderEmailNotification: number;
    public OverdueCasesEmailNotification: number;
    public AnnualReminderLastSent: Date;
    public OverdueCasesLastSent: Date;
}

